import axios from 'axios'
import { Statistics } from '@/domain/Statistics'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 統計(CSV)サービス
 */
export default class StatisticsService {
    /** インスタンス */
    private static _instance: StatisticsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new StatisticsService();
        }
        return this._instance;
    }

    /**
     * 受注データを取得
     */
    public async findOrders(serchConditon: SerchConditon): Promise<Statistics[]> {
        return await axios.get("/api/statistics/orders", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Statistics[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 売上見込データを取得
     */
    public async findExpectedSales(serchConditon: SerchConditon): Promise<Statistics[]> {
        return await axios.get("/api/statistics/expected_sales", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Statistics[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 売上データを取得
     */
    public async findSales(serchConditon: SerchConditon): Promise<Statistics[]> {
        return await axios.get("/api/statistics/sales", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Statistics[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Statistics {
        const statistics = data as Statistics
        statistics.receiptOn = statistics.receiptOn || ""
        statistics.deliveryOn = statistics.deliveryOn || ""
        
        return new Statistics({ ...statistics })
    }
}
